import { Copy, FontCursor, TrashBin, Wrench } from "@gravity-ui/icons";
import { Button, Card, Flex, Icon, Text } from "@gravity-ui/uikit";
import { useAction } from "@reatom/npm-react";
import { ApiTokenDto } from "definitions/poizon-sso";
import moment from "moment";
import { useCallback, useMemo } from "react";
import { useScreenSize } from "src/hooks";
import {
  CUSTOM_SIZES,
  MINIMAL_INNER_WIDTH,
} from "src/pages/ProfilePage/ProfilePage.constants";
import { toastHandler, truncateStart } from "src/util";
import { ShowConfirmDialog } from "src/widgets/Alert/Alert";

import { removeUserApiToken } from "../../store/fetchers/removeUserApiToken";
import css from "./ApiKeyCard.module.scss";
interface ApiKeyProps {
  apiKey: ApiTokenDto;
}
export const ApiKeyCard = ({ apiKey }: ApiKeyProps) => {
  const screenSize = useScreenSize();
  const isMaximized = screenSize.width <= MINIMAL_INNER_WIDTH;
  const customSizes = CUSTOM_SIZES(isMaximized);
  const removeApiToken = useAction(removeUserApiToken);

  const createdDate = useMemo(
    () => moment(apiKey.createdAt).format("DD.MM.YYYY"),
    [apiKey.createdAt],
  );

  const handleCopy = useCallback(async () => {
    await navigator.clipboard.writeText(apiKey.token);
    toastHandler.success({
      title: "Ключ скопирован!",
      content: apiKey.token,
      name: "copykey",
    });
  }, [apiKey.token]);

  const handleDelete = useCallback(async () => {
    const result = await ShowConfirmDialog(
      "Вы действительно хотите удалить ключ?",
      "Подтвердите действие",
    );
    if (result) removeApiToken(apiKey.token);
  }, [apiKey.token, removeApiToken]);

  return (
    <Card className={css.apiKeyCard} view="filled" theme="normal" size="m">
      <Flex direction="column">
        <Text variant="subheader-2" color="warning-heavy">
          {truncateStart(apiKey.token)}
        </Text>

        <Text variant="caption-2" color="secondary">
          создан {createdDate} {customSizes.elementWidth}
        </Text>
      </Flex>

      <Flex
        direction="row"
        wrap="wrap"
        gap="0.5"
        width={customSizes.elementWidth}
        justifyContent="end"
      >
        <Button view="flat" size={customSizes.button} disabled>
          <Icon data={FontCursor} size={customSizes.icon} />
        </Button>
        <Button view="flat" size={customSizes.button} onClick={handleCopy}>
          <Icon data={Copy} size={customSizes.icon} />
        </Button>
        <Button view="flat" size={customSizes.button} disabled>
          <Icon data={Wrench} size={customSizes.icon} />
        </Button>
        <Button view="flat" size={customSizes.button} onClick={handleDelete}>
          <Icon data={TrashBin} size={customSizes.icon} />
        </Button>
      </Flex>
    </Card>
  );
};
